// extracted by mini-css-extract-plugin
export default {"sideBar":"Spreadsheets_sideBar__0lHao","mainContent":"Spreadsheets_mainContent__fwMCV"};